import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AppMobile from './pages/appmobile';
import GesDent from './pages/gestdent';
import Home from './pages/Home';

const App = () => {
  return (

    // <Home/>
    <div>
      <BrowserRouter>
        <Routes>
          <Route index element={<Home/>}/>
          <Route path='/home' element={<Home/>}/>
          <Route path='/Cabinet' element={<GesDent/>}/>
          <Route path='/AppMobile' element={<AppMobile/>}/>
        </Routes>
      </BrowserRouter>
    </div>
  )
};

export default App;
